module.exports = __webpack_public_path__ + "img/inh_logo.055361bf.png";